"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconBeer = function SvgIconBeer(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "beer icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Beer Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.696 22.417h-4.75v-.159c.792-.791 1.425-1.9 1.584-3.166.158-1.584-.317-3.167-1.425-4.275-.792-.792-1.742-1.425-2.692-1.584C30.305 8.325 26.188 5 21.28 5c-4.909 0-9.025 3.325-9.975 8.075-1.109.317-2.059.792-2.85 1.742-1.109 1.108-1.584 2.691-1.425 4.275.158 1.266.633 2.375 1.583 3.166v19.159c0 .95.633 1.583 1.583 1.583h22.167c.95 0 1.583-.633 1.583-1.583v-6.334h1.584c2.691 0 4.75-2.058 4.75-4.75V24c0-.95-.634-1.583-1.584-1.583zM10.83 16.875c.475-.475 1.108-.792 1.583-.792.475 0 .792 0 1.108-.316.317-.317.475-.634.634-1.109.316-3.641 3.483-6.491 7.125-6.491 3.641 0 6.808 2.85 7.125 6.491 0 .475.316.792.633 1.109.317.158.633.316.95.316.633 0 1.267.317 1.742.792.475.475.633 1.108.633 1.9-.158 1.267-1.267 2.058-2.533 2.058h-8.55c-.95 0-1.584.634-1.584 1.584v6.333c0 .95-.633 1.583-1.583 1.583S16.53 29.7 16.53 28.75v-6.333c0-.95-.634-1.584-1.584-1.584H12.73c-1.267 0-2.375-.95-2.534-2.058 0-.792.159-1.425.634-1.9zm26.283 13.458c0 .95-.633 1.584-1.583 1.584h-1.584v-6.334h3.167v4.75z"
  }));
};

var _default = SvgIconBeer;
exports.default = _default;